// extracted by mini-css-extract-plugin
export default {"row":"CpaConditions_row__ge06Q","adornment":"CpaConditions_adornment__7Z46Z"};